<div id="wrapper">
  <div class="page-overlay">
    <div class="preloader-wrap">
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>

  <!-- header begin -->
  <header class="transparent scroll-light">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12" style="padding: 0px 40px; ">
          <!-- logo begin -->
          <div id="logo">
            <a routerLink="/home" routerLinkActive="active">
              <img
                class="logo cus_logo_icon"
                src="assets/images/nimi.png"
                alt=""
                width="100px"
              />
              <img
                class="logo-2"
                src="assets/images/nimi.png"
                alt=""
                width="100px"
              /><span class="cus_logo"
                >National Instructional Media Institute</span
              >
            </a>
          </div>
          <!-- logo close -->

          <!-- small button begin -->
          <span id="menu-btn"></span>
          <!-- small button close -->

          <!-- mainmenu begin -->
          <nav>
            <ul id="mainmenu">
              <li routerLink="/home" routerLinkActive="active">
                <a> Home </a>
              </li>
              <li routerLink="/about" routerLinkActive="active">
                <a> About Us</a>
              </li>

              <li routerLink="/vacancy" routerLinkActive="active">
                <a>Job Listings</a>
              </li>
              <li><a> Register </a></li>
              <li routerLink="/contact" routerLinkActive="active">
                <a> Contact</a>
              </li>
              <li routerLink="/contact" routerLinkActive="active">
                <a> Login </a>
              </li>
            </ul>
          </nav>
          <!-- mainmenu close -->
        </div>
      </div>
    </div>
  </header>
  <!-- header close -->
  <router-outlet></router-outlet>

  <!-- footer begin -->
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-md-6 sm-mb10">
          <div class="mt10">&copy; Content owned and provided by NIMI | Chennai   </div>
        </div>

        <div class="col-md-6 text-left text-md-right">
          <div class="social-icons">
            <a href="#"><i class="fa fa-facebook fa-lg"></i></a>
            <a href="#"><i class="fa fa-twitter fa-lg"></i></a>
            <a href="#"><i class="fa fa-linkedin fa-lg"></i></a>
            <a href="#"><i class="fa fa-google-plus fa-lg"></i></a>
            <a href="#"><i class="fa fa-rss fa-lg"></i></a>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- footer close -->

  <a href="#" id="back-to-top"></a>

  <div id="preloader">
    <div class="preloader1"></div>
  </div>
</div>

<style>
  .cus_logo {
    font-family: "Quicksand";
    font-size: 20px;
    color: #fff;
    padding: 0px 10px;
    font-weight: bolder;
  }
  .clone.smaller .cus_logo {
    color: #000;
  }
  .cus_logo_icon,
  .logo-2 {
    position: relative;
    top: 10px;
  }
  .scroll-light{
    background: rgba(0,0,0,0.2);
  }
  #mainmenu a{
    cursor: pointer;
  }
  #logo a:hover{
    text-decoration: none;
  }
</style>
